import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { EnvironmentConfiguration, PollyAuthService, WindowService } from 'polly-commons';
import { environment } from '../../../../../../../environments/environment';

@Component({
  selector: 'app-polly-manage-application-header',
  templateUrl: './polly-manage-application-header.component.html',
  styleUrls: ['./polly-manage-application-header.component.scss'],
})
export class PollyManageApplicationHeaderComponent implements OnInit {
  private readonly windowService = inject(WindowService);
  private readonly authService = inject(PollyAuthService);
  private readonly environment: EnvironmentConfiguration = environment;
  public logoSrc!: string;
  @Input() public appHeaderName: string = '';
  @Output() public closeEvent = new EventEmitter<void>();

  constructor() {}

  public ngOnInit(): void {
    this.logoSrc = `${this.environment.staticAssets}shared-assets/images/icons/main_logo.svg`;
  }

  public logout(): void {
    this.closeEvent.emit();
    this.authService.logout('/');
  }

  public openPollyDocs(): void {
    const redirectUrl: string = 'index.html';
    const hostName = 'https://docs.elucidata.io/';
    this.windowService.openInNewTab(redirectUrl, hostName);
  }
}
